<template>
  <div>
    <div class="flex-container">
      <div class="card">
        <div class="title">延时信息</div>
        <div style="margin-bottom: 15px; margin-left: 30px">
          现拟结项申请日期： {{ baseInfo.closingItemApplyTime }}
        </div>
      </div>
      <div class="table">
        <div class="title">管理组检查情况</div>
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            style="
              margin-left: 15px;
              color: #fff;
              background-color: #1c84c6;
              border-color: #1c84c6;
            "
            @click="addAdviceDialog = true"
            :disabled="baseInfo.isAdd == 0 || tableList.length >= 1"
            >意见反馈</el-button
          >
        </div>
        <el-table
          :max-height="height"
          :data="tableList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <el-table-column
            label="操作"
            align="left"
            min-width="150px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click="handleChangeEditDialog(scope.row)"
                size="mini"
                >编辑</el-button
              >
              <el-button
                type="danger"
                @click="delCheckItem(scope.row.feedbackId)"
                size="mini"
                >删除</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            label="反馈人"
            align="left"
            prop="xm"
            min-width="80px"
            :show-overflow-tooltip="true"
          />

          <el-table-column
            label="反馈时间"
            align="left"
            prop="feedbackTime"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="意见反馈"
            align="left"
            prop="content"
            min-width="250px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="状态"
            align="left"
            prop="statusName"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <div class="table_count">共{{ tableList.length }}条记录</div>
      </div>
      <div class="card">
        <div class="steps">
          <div class="title">课题延期结项申请</div>

          <el-col
            :span="24"
            v-for="(item2, index2) in baseInfo.metaPropList"
            :key="index2"
          >
            <div class="content">
              <div v-if="item2.type == 1">
                <div class="content_title">
                  <span v-if="item2.required == '1'" class="red">*</span>
                  <span>{{ item2.cname }}</span>
                </div>
                <div class="content_text">
                  <el-input
                    v-model="item2.propValue"
                    type="textarea"
                    :autosize="{ minRows: 6 }"
                    show-word-limit
                  ></el-input>
                </div>
              </div>
              <div v-else>
                <div class="content_title">
                  <span v-if="item2.required == '1'" class="red">*</span>
                  <span>{{ item2.cname }}</span>
                </div>
                <div :id="`wangEditor_yqjx_result_${index2}`"></div>
              </div>
            </div>
          </el-col>
        </div>
      </div>
    </div>
    <div v-if="addAdviceDialog">
      <el-dialog
        title="意见反馈"
        :visible.sync="addAdviceDialog"
        append-to-body
        width="900px"
        :closeOnClickModal="false"
      >
        <div style="display: flex">
          <span style="width: 72px; text-align: right; margin-right: 15px">
            状态
            <span style="color: #ff0000">*</span>:
          </span>
          <span>
            <el-radio-group v-model="addAdviceForm.status">
              <el-radio label="5">不通过</el-radio>
              <el-radio label="4">通过</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="line-height: 44px">
          意见反馈
          <span style="color: #ff0000">*</span>：
        </div>
        <el-input
          type="textarea"
          v-model="addAdviceForm.content"
          :autosize="{ minRows: 6, maxRows: 12 }"
          maxlength="3000"
          show-word-limit
          placeholder="请输入意见反馈"
        />
        <span slot="footer" class="dialog-footer">
          <el-button @click="addAdviceDialog = false">取 消</el-button>
          <el-button type="primary" @click="addAdvice">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import {
  getDelayClosing,
  insertClosingFeedback,
  deleteInspection,
} from "@/api/course.js";
import wangEditor from "wangeditor";

export default {
  name: "courseLxsq",
  computed: {},
  props: ["mxParams"],
  computed: {
    ...mapGetters(["user"]),
  },
  data() {
    return {
      tableList: [],
      baseInfo: {},
      editorList: [],
      addAdviceDialog: false,
      addAdviceForm: {
        status: "4",
        content: null,
      },
      feedbackId: null,
    };
  },

  created() {
    this.getData();
  },
  mounted() {
    const timer = setInterval(() => {
      if (this.baseInfo.metaPropList && this.baseInfo.metaPropList.length > 0) {
        for (let i in this.baseInfo.metaPropList) {
          let editor = new wangEditor(`#wangEditor_yqjx_result_${i}`);
          editor = this.editorConfig(editor);
          editor.txt.html(this.baseInfo.metaPropList[i].propValue);
          this.editorList.push(editor);
          document.querySelector(
            `#wangEditor_yqjx_result_${i} .w-e-text-container`
          ).style.backgroundColor = "#f3f3f3";
          document.querySelector(
            `#wangEditor_yqjx_result_${i} .w-e-toolbar`
          ).style.backgroundColor = "#f3f3f3";
        }
        clearInterval(timer);
      }
    }, 50);
  },
  methods: {
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中

      editor.create();
      // editor.disable();
      return editor;
    },
    getData() {
      getDelayClosing({ courseId: this.mxParams.id }).then((res) => {
        if (res.code == 0) {
          this.tableList = res.data.feedbackList;
          this.baseInfo = res.data.courseInfo;
        }
      });
    },
    addAdvice() {
      if (!this.addAdviceForm.status) {
        this.$message.error("状态不能为空！");
        return;
      }
      if (!this.addAdviceForm.content) {
        this.$message.error("意见反馈不能为空！");
        return;
      }
      const { courseId, linkId, step } = this.baseInfo;
      insertClosingFeedback({
        ...this.addAdviceForm,
        courseId,
        linkId,
        step: "10",
        feedbackTime: "",
        ygbh: this.user.ygbh,
        feedbackId: this.feedbackId,
        statusName: this.addAdviceForm.status == 4 ? "通过" : "不通过",
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.addAdviceDialog = false;
          this.feedbackId = null;
          this.addAdviceForm = {
            status: "4",
            content: null,
          };
          this.getData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleChangeEditDialog(row) {
      this.addAdviceForm = {
        status: row.status,
        content: row.content,
      };
      this.feedbackId = row.feedbackId;
      this.addAdviceDialog = true;
    },
    delCheckItem(feedbackId) {
      deleteInspection({ feedbackId }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getData();
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.flex-container {
  width: 100%;
  height: 100%;
}
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin: 15px 0;
}
.title {
  font-size: 15px;
  font-weight: bold;
  padding-left: 15px;
  line-height: 42px;
  height: 42px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
}
.table_count {
  color: #666;
  margin: 10px 15px;
}
.result {
  margin-bottom: 15px;
  .result_detail {
    font-size: 14px;
    background: #f3f3f3;
    line-height: 32px;
    padding-left: 15px;
    margin: 0 15px;
    color: #666;
  }
}

.content {
  margin-bottom: 30px;
  line-height: 32px;
  font-size: 14px;
  .content_title {
    font-weight: 700;
  }
  .content_text {
    background-color: #f3f3f3;
    padding: 0 15px;
    margin-right: 15px;
  }
}
.red {
  color: #ff0000;
  margin-right: 5px;
}
</style>